import { AxiosResponse } from 'axios';
import apiService from './api';
import {
  TeacherLoginResponse,
  TeacherLoginDetailResponse,
  TeacherLoginQueryParams,
} from 'shared/types';

const REPORTS_PATH = '/reports';

export const getTeacherLogins = (
  params?: TeacherLoginQueryParams
): Promise<AxiosResponse<TeacherLoginResponse>> => {
  return apiService.get<TeacherLoginResponse>(`${REPORTS_PATH}/teacher-logins`, params);
};

export const getTeacherLoginDetail = (
  userId: string,
  params?: { dateFrom?: string; dateTo?: string }
): Promise<AxiosResponse<TeacherLoginDetailResponse>> => {
  return apiService.get<TeacherLoginDetailResponse>(
    `${REPORTS_PATH}/teacher-logins/${userId}`,
    params
  );
};
